import React, { useState } from 'react';
import { compose } from 'recompose';
import { observer } from 'mobx-react';

import { StyledTabs } from '../../components/ClientInfo/styles';
import { HeaderRow, TitleContainer, Title } from '../../../components/v2/Header';

import UserManagement from '../../components/UserManagement';
import { UserRole } from '../../../Model/User';
import texts from './texts';

const InternalUsers = () => {
  const [selectedRole, setSelectedRole] = useState(UserRole.AC);

  return (
    <>
      <HeaderRow>
        <TitleContainer>
          <Title>{texts.internalUsers}</Title>
        </TitleContainer>
      </HeaderRow>
      <StyledTabs
        tabsConfig={{
          [UserRole.AC]: { label: texts.tabLabels[UserRole.AC] },
          [UserRole.CAM]: { label: texts.tabLabels[UserRole.CAM] },
          [UserRole.CPS]: { label: texts.tabLabels[UserRole.CPS] },
          [UserRole.IS]: { label: texts.tabLabels[UserRole.IS] },
          [UserRole.SDR]: { label: texts.tabLabels[UserRole.SDR] },
          [UserRole.SUPPORT]: { label: texts.tabLabels[UserRole.SUPPORT] },
        }}
        selectedTab={selectedRole}
        onSelectTab={setSelectedRole}
      />
      <UserManagement role={selectedRole} />
    </>
  );
};

export default compose(
  observer,
)(InternalUsers);
